export function SortFilesAlphabetically(array) {
  array.sort((a, b) => {
    const parenthesisRegex = /^([^\(]+?)(?:\((\d+)\))?$/;
    
    // Match base names and optional numeric suffixes
    let matchA = a.objectName.match(parenthesisRegex);
    let matchB = b.objectName.match(parenthesisRegex);

    if (matchA && matchB) {
      // Compare base names (the part before any parentheses)
      let baseNameA = matchA[1].trim();
      let baseNameB = matchB[1].trim();
      let baseComparison = baseNameA.localeCompare(baseNameB);

      if (baseComparison !== 0) {
        // If base names are different, return that comparison
        return baseComparison;
      }

      // If base names are the same, compare the numbers in parentheses (if they exist)
      let numA = matchA[2] ? parseInt(matchA[2], 10) : 0; // Treat no number as 0 (original file)
      let numB = matchB[2] ? parseInt(matchB[2], 10) : 0;
      
      return numA - numB; // Sort by numeric suffix
    }

    // Fallback to localeCompare if something goes wrong
    return a.objectName.localeCompare(b.objectName);
  });
}
